import * as React from 'react';
import PropTypes from 'prop-types';
import {Icon, Segment} from "semantic-ui-react";
import {Subbar, Title, PageHeader} from "ah-tools";
import ServiceForm from "./ServiceForm";
import {translate} from "react-i18next";
import {ROUTE_SERVICE} from "../routes";
import {IconButton} from "../extensions";

class ServiceCreate extends React.Component {
	static propTypes = {
		isLoading: PropTypes.bool,
		onCreate: PropTypes.func.isRequired,
		push: PropTypes.func
	};
	static defaultProps = {
		isLoading: false,
		onCreate: () => alert('onCreate() is not implemented')
	};
	state = {};
	
	render() {
		const {isLoading, onCreate, push} = this.props;
		return (
			<Segment basic>
				<PageHeader>
					<Subbar>
						{push &&
							<IconButton onClick={() => push(ROUTE_SERVICE)}>
								<Icon name={'chevron left'} size={'large'}/>
							</IconButton>
						}
						<Title loading={isLoading}>Serviceleistung erstellen</Title>
					</Subbar>
				</PageHeader>
				<ServiceForm
					isSaving={isLoading}
					onSave={onCreate}
				/>
			</Segment>
		);
	}
}

export default translate()(ServiceCreate);


// WEBPACK FOOTER //
// ./src/components/ServiceCreate.js